import styled from 'styled-components'


export const CountDownText = styled.p`
  font-family: 'Poppins', sans-serif !important;
`

export default {}
